import { render, staticRenderFns } from "./Bonus.vue?vue&type=template&id=5c0c69be&scoped=true"
import script from "./Bonus.vue?vue&type=script&lang=ts"
export * from "./Bonus.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c0c69be",
  null
  
)

export default component.exports